import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";

interface accordionItem {
  label: string;
  path: string;
  allowed?: boolean;
  icon?: ReactNode;
}
interface accordionProp {
  data: accordionItem[];
  title: string;
  icon: ReactNode;
  allowed?: boolean;
}
const AccordionCustom: React.FC<accordionProp> = ({
  data,
  title,
  icon,
  allowed,
}) => {
  return (
    <>
      <Accordion type="single" className="py-0  text-[#FAFAFA]" collapsible>
        <AccordionItem className="border-none" value="item-1">
          {allowed && (
            <AccordionTrigger className="outline-none hover:outline-noner hover:underline-none">
              <div className="flex text-[16px] items-center">
                {" "}
                <div className="icon ms-[5px] me-[10px] ">{icon}</div> {title}
              </div>
            </AccordionTrigger>
          )}
          <AccordionContent>
            <div className="ps-[30px] ">
              {data.length > 0 ? (
                data?.map((item, index) => (
                  <>
                    {item?.allowed && (
                      <AccordionContent className="mt-3 w-full" key={index}>
                        <div className="mb-0">
                          <NavLink
                            to={item.path || "#"}
                            className={
                              "navlink w-full mb-0 flex gap-3 text-[16px] font-medium items-center"
                            }
                          >
                            {item.label}
                          </NavLink>
                        </div>
                      </AccordionContent>
                    )}
                  </>
                ))
              ) : (
                <i>No record found</i>
              )}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
};

export default AccordionCustom;
